import { createContext } from 'react';

export const EditableContext = createContext<boolean>(true);